import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { Grid } from '@/common/grid/Grid';
import { ContentBox } from '@/common/layout/ContentBox.jsx';
import { useNavState } from '@/common/navState/NavStateContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useEffect, useRef, useState } from 'react';
export const GpoRosterGrid = ({ periodId, gpo, searchType, searchValue }) => {
  const rsrc = useRsrc();
  const { navigateTo } = useNavState();

  const [data, setData] = useState([]);
  const [fieldDefs, setFieldDefs] = useState([]);
  const gridRef = useRef(null);

  const [isGridReady, setIsGridReady] = useState(false);

  useEffect(() => {
    if (periodId == null && !searchValue?.trim() && gpo == null) return;
    rsrc.data('md', 'GPO_ROSTER_GRID_DATA_PLUGIN', { periodId, gpo, searchType, searchValue }).then((res) => {
      setData(res);
    });
  }, [rsrc, periodId, gpo, searchType, searchValue]);

  useEffect(() => {
    setFieldDefs([
      { field: 'gpo', displayName: 'GPO' },
      { field: 'type', displayName: 'Type' },
      { field: 'ident1', displayName: 'GPO ID' },
      { field: 'name', displayName: 'Name' },
      { field: 'ident2', displayName: 'HIN' },
      { field: 'ident3', displayName: 'DEA' },
      { field: 'parentId', displayName: 'Parent ID' },
      { field: 'periodCode', displayName: 'Period Code' },
    ]);
  }, []);

  useEffect(() => {
    if (isGridReady && gridRef.current) {
      gridRef.current.setDataSource(data);
    }
  }, [isGridReady, data]);

  const onGridReady = () => {
    setIsGridReady(true);
  };

  const getContextMenuItems = (params) => {
    if (!params?.node?.data?.id) {
      return [{ name: 'No options available', disabled: true }];
    }

    return [
      {
        name: 'View History',
        icon: fas.faHistory,
        action: () =>
          navigateTo('md/gpo-cust-view', {
            mode: Mode.DETAIL,
            entityId: params.node.data.id,
            periodId: params.node.data.periodId ?? periodId,
            ident1: params.node.data.ident1,
            gpo: params.node.data.gpo,
            code: params.node.data.code,
            name: params.node.data.name,
          }),
      },
    ];
  };

  return (
    <ContentBox>
      <Grid
        key={JSON.stringify(fieldDefs)}
        ref={gridRef}
        gridOptions={{
          fieldDefs,
          rowModelType: 'clientSide',
          getContextMenuItems,
        }}
        events={{
          onGridReady,
        }}
      />
    </ContentBox>
  );
};
